// src/Redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import pestTypesReducer from './pestTypesSlice';

const store = configureStore({
  reducer: {
    pestTypes: pestTypesReducer,
  },
});

export default store;
